











































import Component, { mixins } from "vue-class-component";
import AxiosMixin from "@/mixins/axiosMixin";
import { Emit } from "vue-property-decorator";
import LoadingDialog from "../common/LoadingDialog.vue";
import { BeppyoDiseaseCodeMaster } from "./types";

@Component({
  components: {
    LoadingDialog
  }
})
export default class DiseaseSettingDialog extends mixins(AxiosMixin) {
  private masters: BeppyoDiseaseCodeMaster[] = [];
  private headers = [
    {
      value: "div_name",
      text: "区分",
      width: "10%"
    },
    {
      value: "code",
      text: "コード",
      width: "15%"
    },
    {
      value: "name",
      text: "名称",
      width: "75%"
    }
  ];
  private selectItems: BeppyoDiseaseCodeMaster[] = [];
  private beppyou_codes: string[] = [];
  private isActive = false;

  public open(beppyou_code: string) {
    this.beppyou_codes = beppyou_code.split(" ");
    this.updateData();
    this.isActive = true;
  }

  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/medical/edit/get_disease_masters",
      {},
      res => {
        this.masters = res.data.masters;
        this.selectItems = this.masters.filter(s => {
          return this.beppyou_codes.includes(s.code);
        });
        console.log(this.beppyou_codes);
        console.log(this.selectItems);
      }
    );
  }

  private clickSelect() {
    const beppyou_code = this.selectItems
      .map(x => x.code)
      .reduce((acc, x) => (acc += " " + x));
    if (confirm("「" + beppyou_code + "」を反映します。よろしいですか？")) {
      this.select(beppyou_code);
      this.isActive = false;
    }
  }

  private clickCancel() {
    this.isActive = false;
  }

  @Emit()
  select(beppyou_code: string) {
    return beppyou_code;
  }
}
